/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import WelcomeBody from './WelcomeBody';
import './index.scss';
import { InternationalizationContext } from '../../../../src/Utils/Contexts';
import Slider from 'react-slick';
import { Tooltip } from '@mui/material';
import {
	BackwardWelCarousel,
	ForwardWelCarousel,
	SendIconButton,
} from '../../../Components/FeatureComponents/Buttons/IconButton/Icons';
import { WelcomeCarousel } from './styles/theme1/theme1.styled';
import { Carousel } from 'react-responsive-carousel';
import GenericImage from '../../../../assets/imgs/GenericImage.png';
import { loadStateSession } from '../../FlyfishComponents/flyfishutils/utils';
import { FlyfishIcon } from '../../FlyfishComponents/flyfishIcons/icons';
import { ShopperStopLine } from '../../FlyfishComponents/flyfishIcons/icons';
import { ShopperstopLogo } from '../../FlyfishComponents/flyfishIcons/icons';
import { ShopperstopLogoMobile } from '../../FlyfishComponents/flyfishIcons/icons';
import IconButton from '../../../Components/FeatureComponents/Buttons/IconButton/IconButton';
const CustomWelcomeBody = styled(WelcomeBody)`
	padding: 24px 6%;
	overflow: auto;
	& + .PoweredByTheme1 {
		.flyfishlogo_class_001_theme1 {
			fill: url(#linear-gradient_theme1);
			stroke-width: 0px;
		}
		.flyfishlogo_class_002_theme1 {
			stroke-width: 0px;
		}
		.flyfishlogo_class_003_theme1 {
			fill: none;
			stroke: #000;
			stroke-miterlimit: 10;
			stroke-width: 20px;
		}
	}
`;

const WelcomeText = styled.div`
	padding: 24px;
	& > .welcome-heading {
		color: ${(props) =>
			props.data.colorMode === 'dark'
				? 'var(--selectedColor)'
				: props.data.colorScale[0]};
		font-weight: bold;
		font-family: var(--fontFamily);
		margin: 0;
		text-align: center;
		overflow-wrap: break-word;
		font-size: 1.582rem;
	}
	& > .welcome-explore {
		display: none;
		color: ${(props) =>
			props.data.colorMode === 'dark' ? '#ffffff' : props.data.colorScale[0]};
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.28);
		font-weight: 600;
		margin-top: 16px;
		margin-bottom: 8px;
		font-family: var(--fontFamily);
	}

	& > .welcome-typebox {
		background-color: transparent;
		border-radius: 10px;
		height: 60px;
		margin-top: 30px;
		display: flex;
		margin-bottom: 20px;
		justify-content: center;
		&.E-commerce.Chat {
			margin-top: 9px !important;
		}

		.welcome-typo-header {
			& > .ff-home-input-box-holder {
				position: relative;
				display: flex;
				align-items: center;
				width: 100%;
				& > input {
					outline: none;
					border: none;
					width: 100%;
					font-size: var(--fontSize);
					background-color: transparent;
					font-family: var(--fontFamily);
					z-index: 1;
				}
				& > p.animation-text {
					position: absolute;
					left: 3px;
					margin: 0;
					width: 100%;
					color: rgba(0, 0, 0, 0.6);
					font-size: var(--fontSize);
					font-family: var(--fontFamily);
					&:not(.stopAnimation) {
						animation: slideUpDown 2.5s ease-out infinite;
					}
					&.hide {
						visibility: hidden;
					}
				}
				@keyframes slideUpDown {
					0% {
						transform: translateY(20px);
						opacity: 0;
					}
					20%,
					25%,
					30%,
					35%,
					40%,
					45%,
					50%,
					55%,
					60%,
					70%,
					75%,
					80% {
						transform: translateY(0);
						opacity: 1;
					}

					100% {
						transform: translateY(-8px);
						opacity: 0;
					}
				}

				@-webkit-keyframes slideUpDown {
					0% {
						transform: translateY(20px);
						opacity: 0;
					}
					20%,
					25%,
					30%,
					35%,
					40%,
					45%,
					50%,
					55%,
					60%,
					70%,
					75%,
					80% {
						transform: translateY(0);
						opacity: 1;
					}

					100% {
						transform: translateY(-8px);
						opacity: 0;
					}
				}

				@-moz-keyframes slideUpDown {
					0% {
						transform: translateY(20px);
						opacity: 0;
					}
					20%,
					25%,
					30%,
					35%,
					40%,
					45%,
					50%,
					55%,
					60%,
					70%,
					75%,
					80% {
						transform: translateY(0);
						opacity: 1;
					}

					100% {
						transform: translateY(-8px);
						opacity: 0;
					}
				}
			}
			padding: 8px 12px 8px 16px;
			border-radius: 20px;
			box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.28);
			border: solid 2px rgba(0, 0, 0, 0.2);
			height: 52px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 66%;
			&.monaco,
			&.E-commerce.Chat {
				border: 1px solid var(--selectedColor);
				border-radius: 0px;
				margin-top: 20px;
				height: 45px;
				margin-bottom: 10px;
				box-shadow: none;
				width: 75%;
				max-width: 945px;
				margin-top: 0px;
				background-color: #fff;
			}

			& > div:not(div.ff-home-input-box-holder) {
				display: flex;
				align-items: center;
				& > svg {
					cursor: pointer;
				}
			}
			& > input {
				&::placeholder {
					color: rgba(0, 0, 0, 0.6);
					opacity: 1;
				}

				&:-ms-input-placeholder {
					color: rgba(0, 0, 0, 0.6);
				}

				&::-ms-input-placeholder {
					color: rgba(0, 0, 0, 0.6);
				}
			}
		}
	}

	& > .welcome-simplify {
		padding: 16px;
		display: none;
		border-radius: 12px;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.28);
		background-color: white;
		margin-top: 12px;
		& > p:first-child {
			color: black;
			font-family: var(--fontFamily);
			font-weight: bold;
			margin: 0px;
			margin-bottom: 12px;
		}
		& > p:last-child {
			color: rgba(0, 0, 0, 0.6);
			font-family: var(--fontFamily);

			margin: 0px;
		}
	}
`;
export const MonacoHomeScreen = styled.div`
   height: 70vh;
    margin-top: -14px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -20px;
	width:100%;
	max-height: 548px;
	@media only screen and (max-width: 700px) {
		
		max-height: unset;
	}

	>div{
		&:nth-of-type(1){
			width: 85%;
			background-color: #fff;
			height: 108%;
			display:flex;
			max-width: 1300px;
			max-height: 548px;
			
			@media only screen and (max-width: 700px) {
				flex-direction: column;
				width: auto;
				height: 100%;
				max-height:unset;
				max-width: 80vw;
				aspect-ratio: 6 / 8;
			}
		
			>.ff-monaco-welcome-cnt{
				@media only screen and (max-width: 700px) {
					 width:100%;
					 height: 50%;
					 padding-left:0px;
					 padding-right:0px;

				}
			
				>.ff-chatbot-h4{
					@media only screen and (max-width: 700px) {
				    font-size: 20px;
					text-align:center;
					}
				}
				>div{
					&:nth-of-type(2){
						@media only screen and (max-width: 700px) {
							font-size: 12px !important;
							text-align:center;
							line-height: 20px !important;
							margin-top: 5px;
							}
					}
				}
			}
			>.ff-monaco-welcome-image{
				@media only screen and (max-width: 700px) {
					width:100% !important;
					height: 50%;
				}
				>img{
					aspect-ratio: 1.2;
					object-fit: cover;
				}
			
				  
				}
				
			}
			>div{
				&:nth-of-type(1){
					width: 90%;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					font-family:var(--fontFamily);
					padding-left: 24px;
				}
			}
		}
	}
   
`;
const QuickLinksBlock = styled.div`
	display: flex;
	flex-direction: column;
	margin: 20px 0;
`;

const CustomQuickLink = styled.div`
	border-bottom: 0.5px solid #606a91;
	display: flex;
	align-items: center;
	padding: 15px 0;

	> img {
		margin-left: 30px;
	}

	& > div {
		font-size: 14px;
		color: #fff;
		width: 100%;
		border: 0;
		border-radius: 0;
		background: transparent;
		padding: 0;
		margin: 0;
		margin-left: 15px;
	}

	& > div:hover {
		background: transparent;
		animation: none;
	}
`;

const WelcomeFooter = styled.div`
	height: 60px;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	padding: 20px 0px;
	border-top: 1px solid #ccc;
	background-color: #ffffff;
	z-index: 999;
	& div {
		img {
			width: 20px;
			height: 20px;
		}
	}
`;
const Theme1 = (props) => {
	let placeholderValue = loadStateSession('searchBoxPlaceholder');
	const placeholders =
		placeholderValue === 'NA' || placeholderValue === ''
			? 'Type your query'
			: JSON.parse(placeholderValue);
	const [currentPlaceholderIndex, setCurrentPlaceholderIndex] = useState(0);
	const inputRef = useRef(null);
	const [animationCycleComplete, setAnimationCycleComplete] = useState(false);
	const [isInputFocus, setIsInputFocus] = useState(false);
	useEffect(() => {
		const onAnimationIteration = () => {
			setAnimationCycleComplete(true);
		};

		document
			.querySelector('.animation-text')
			.addEventListener('animationiteration', onAnimationIteration);

		return () => {
			document
				.querySelector('.animation-text')
				.removeEventListener('animationiteration', onAnimationIteration);
		};
	}, []);

	useEffect(() => {
		setTimeout(() => {
			if (document.activeElement === inputRef.current) {
				if (
					props.selectedTheme === 'monaco' ||
					props.selectedTheme === 'E-commerce Chat'
				)
					setIsInputFocus(true);
			} else {
				setIsInputFocus(false);
			}
		}, 100);
	}, []);
	useEffect(() => {
		if (animationCycleComplete) {
			console.log('Animation cycle complete. Changing text...');
			setAnimationCycleComplete(false); // Reset the flag
			setCurrentPlaceholderIndex(
				(prevIndex) => (prevIndex + 1) % placeholders.length
			);
		}
	}, [animationCycleComplete]);

	useEffect(() => {
		if (window.innerWidth < 800 || window.screen.width < 800) {
			setMobile(true);
		} else {
			setMobile(false);
		}
		window.addEventListener(
			'resize',
			function (event) {
				if (window.innerWidth < 800 || window.screen.width < 800) {
					setMobile(true);
				} else {
					setMobile(false);
				}
			},
			true
		);
	});
	const [mobile, setMobile] = useState(false);
	const slider = React.useRef();

	const next = () => {
		slider.current.slickNext();
	};
	const previous = () => {
		slider.current.slickPrev();
	};
	const settings = {
		dots: false,
		infinite: false,
		slidesToScroll: 1,
		slidesToShow: 3,
		prevArrow: (
			<div
				className='ff-back-wel'
				onClick={() => {
					previous();
				}}>
				<BackwardWelCarousel
					className='ff-back-wel'
					width='31px'
					height='31px'
					filledColor={props.selectedColor}
					fill={
						props.colorMode === 'dark'
							? '#fff'
							: props.colorScale && props.colorScale[0]
					}
				/>
			</div>
		),
		nextArrow: (
			<div
				onClick={() => {
					next();
				}}>
				<ForwardWelCarousel
					className='ff-next-wel'
					width='24px'
					height='24px'
					filledColor={props.selectedColor}
					fill={
						props.colorMode === 'dark'
							? '#fff'
							: props.colorScale && props.colorScale[0]
					}
				/>
			</div>
		),
	};
	const intlContext = React.useContext(InternationalizationContext);
	const [inputText, setInputText] = useState('');
	// const quickLinks = JSON.parse(props.data.quicklinks);
	useEffect(() => {
		if (props.voiceText.length > 0) {
			setInputText(props.voiceText);
		}
	}, [props.voiceText]);
	useEffect(() => {
		if (window.innerWidth < 800 || window.screen.width < 800) {
			setMobile(true);
		} else {
			setMobile(false);
		}
		window.addEventListener(
			'resize',
			function (event) {
				if (window.innerWidth < 800 || window.screen.width < 800) {
					setMobile(true);
				} else {
					setMobile(false);
				}
			},
			true
		);
	});

	return (
		<React.Fragment>
			<CustomWelcomeBody {...props}>
				<div>
					<WelcomeText
						{...props}
						className={`ff-welcome-parent-text ${props.selectedTheme}`}>
						<React.Fragment>
							<h4 className='welcome-heading ff-chatbot-h4'>
								{props.data.FSWelcomeHeading}
							</h4>
							<div style={{ display: 'flex', justifyContent: 'center' }}>
								<div className='ff-chatbot-body1 ff-welcome-subText'>
									{props.data.FSWelcomeSubHeader}
								</div>
							</div>

							<div className={`welcome-typebox ${props.selectedTheme}`}>
								<div
									className={`welcome-typo-header ${props.selectedTheme}`}
									style={{
										border:
											inputText.length > 0
												? '2px solid var(--selectedColor)'
												: props.selectedTheme === 'monaco' ||
												  props.selectedTheme === 'E-commerce Chat'
												? isInputFocus
													? '2px solid var(--selectedColor)'
													: '1px solid var(--black-20)'
												: '1px solid rgba(0, 0, 0, 0.2)',
									}}>
									<div className='ff-home-input-box-holder'>
										<input
											type='text'
											id='WSchatInput'
											className={`welcome-input`}
											autoComplete='off'
											ref={inputRef}
											autoFocus={
												props.selectedTheme === 'monaco' ||
												props.selectedTheme === 'E-commerce Chat'
													? true
													: false
											}
											onFocus={() => {
												if (
													props.selectedTheme === 'monaco' ||
													props.selectedTheme === 'E-commerce Chat'
												)
													setIsInputFocus(true);
											}}
											onBlur={() => {
												if (
													props.selectedTheme === 'monaco' ||
													props.selectedTheme === 'E-commerce Chat'
												)
													setIsInputFocus(false);
											}}
											value={inputText}
											onChange={(ev) => {
												setInputText(ev.target.value);
											}}
											onKeyPress={(ev) => {
												if (ev.key === 'Enter' && inputText.trim().length > 0) {
													props.changeScreen('chatscreen');
													props.submitchanges(inputText);
													// props.changeInput(inputText);
												}
											}}
										/>
										<p
											className={`animation-text ${
												placeholderValue === 'NA' ||
												placeholderValue === '' ||
												placeholders.length === 1
													? 'stopAnimation'
													: 'playAnimation'
											} ${inputText.length > 0 ? 'hide' : ''}`}>
											{loadStateSession('selectedTheme') === 'monaco' ||
											loadStateSession('selectedTheme') === 'E-commerce Chat'
												? inputText.length === 0 &&
												  (placeholderValue === 'NA' ||
														placeholderValue === '' ||
														placeholders.length === 1)
													? placeholders.length === 1
														? placeholders[0]
														: placeholders
													: placeholders[currentPlaceholderIndex]
												: 'Type your query'}
										</p>
									</div>
									<div
										onClick={() => {
											if (inputText.trim().length > 0) {
												props.changeScreen('chatscreen');
												props.submitchanges(inputText);
												// props.changeInput(inputText);
											}
										}}>
										{props.selectedTheme === 'monaco' ||
										props.selectedTheme === 'E-commerce Chat' ? (
											<svg
												xmlns='http://www.w3.org/2000/svg'
												id='send-icn'
												width='13.014'
												height='15.069'
												viewBox='0 0 13.014 15.069'>
												<g
													id='Path_6'
													data-name='Path 6'
													transform='translate(13.014) rotate(90)'>
													<path
														d='M 0.9947404265403748 12.04445552825928 L 7.534533500671387 0.7484385967254639 L 14.07432556152344 12.04445266723633 L 7.714113712310791 8.575236320495605 L 7.534543514251709 8.477286338806152 L 7.354973316192627 8.575236320495605 L 0.9947404265403748 12.04445552825928 Z'
														stroke='none'
														fill='var(--selectedColor)'
													/>
													<path
														d='M 7.534533500671387 1.496898651123047 L 1.989492416381836 11.07470607757568 L 7.534543514251709 8.050126075744629 L 13.0795726776123 11.0747013092041 L 7.534533500671387 1.496898651123047 M 7.534533500671387 -3.814697265625e-06 L 15.06906318664551 13.01419639587402 L 7.534543514251709 8.904445648193359 L 3.814697265625e-06 13.01419639587402 L 7.534533500671387 -3.814697265625e-06 Z'
														stroke='none'
														fill='var(--selectedColor)'
													/>
												</g>
											</svg>
										) : props.data.searchEnabled.includes('voice') &&
										  inputText.trim().length === 0 &&
										  props.selectedTheme === 'Default' ? (
											//this.props.data.searchEnabled.includes('voice') ? (
											<IconButton
												size={'normal'}
												image={'mic'}
												fill={props.data.colorScale[4]}
												variant={'empty'}
												onClick={() => {
													props.enableVoiceModal();
												}}
											/>
										) : (
											<SendIconButton
												fill={
													props.data.colorMode === 'dark'
														? 'var(--selectedColor)'
														: props.data.colorScale[4]
												}
											/>
										)}
									</div>
								</div>
							</div>

							<div className='welcome-simplify'>
								<p className='ff-chatbot-body2'>{props.data.cardHeading}</p>
								<p className='ff-chatbot-body2'>{props.data.cardBody}</p>
							</div>

							{props.data.FSCarouselFieldsData !== '[]' &&
							props.data.FSCarouselFieldsData !== '' ? (
								<div className='welcome-explore ff-chatbot-caption'>
									{props.data.carouselTitle}
								</div>
							) : null}
							<WelcomeCarousel {...props}>
								<div
									className={`ff-welcome-card-car ${
										JSON.parse(props.data.FSCarouselFieldsData).length > 3
											? 'ff-preview-long-card'
											: ''
									}`}>
									{mobile ? (
										<Carousel
											showArrows={true}
											showStatus={false}
											showThumbs={false}
											showIndicators={true}
											centerMode
											centerSlidePercentage={
												(window.innerWidth < 800 && window.innerWidth > 450) ||
												(window.screen.width < 800 && window.screen.width > 450)
													? 50
													: 80
											}
											width={'100%'}
											renderArrowNext={(onClickHandler, hasNext) =>
												hasNext && (
													<button
														className={`carouselButtons clickable right `}
														onClick={onClickHandler}
														style={{
															top: 'unset',
															right: '4px',
															bottom: '50%',
														}}>
														{/* <ArrowRight /> */}
														<ForwardWelCarousel
															filledColor={props.selectedColor}
															fill={
																props.colorMode === 'dark'
																	? '#fff'
																	: props.colorScale && props.colorScale[0]
															}
														/>
													</button>
												)
											}
											renderArrowPrev={(onClickHandler, hasPrev) =>
												hasPrev && (
													<button
														className={`carouselButtons clickable left `}
														onClick={onClickHandler}
														style={{
															top: 'unset',
															left: '20px',
															bottom: '50%',
														}}>
														{/* <ArrowLeft /> */}
														<BackwardWelCarousel
															filledColor={props.selectedColor}
															fill={
																props.colorMode === 'dark'
																	? '#fff'
																	: props.colorScale && props.colorScale[0]
															}
														/>
													</button>
												)
											}>
											{JSON.parse(props.data.FSCarouselFieldsData).map(
												(item, index) => {
													let actionValue =
														item.linkValue.length > 60
															? item.linkValue.slice(0, 60) + '...'
															: item.linkValue;
													return (
														<div
															key={item.linkText}
															style={{ marginRight: '24px', cursor: 'pointer' }}
															className='ff-welcome-card-parent'
															onClick={() => {
																item.linkValue &&
																	props.handleSubmit(item.linkValue);
																item.linkValue &&
																	props.changeScreen('chatscreen');
															}}>
															<img
																src={item.linkText}
																style={{
																	height:
																		item.linkValue.length > 0 ? '70%' : '100%',
																}}
															/>
															<div
																style={{
																	backgroundColor: 'var(--selectedColor)',
																	cursor: 'pointer',
																	color:
																		props.colorMode === 'dark'
																			? `#fff`
																			: props.colorScale[0],
																	display:
																		item.linkValue.length > 0
																			? 'block'
																			: 'none',
																}}>
																<div>
																	{item.linkValue.length > 60 ? (
																		<Tooltip title={item.linkValue}>
																			<p>{actionValue}</p>
																		</Tooltip>
																	) : (
																		<p>{actionValue}</p>
																	)}
																</div>
															</div>
														</div>
													);
												}
											)}
										</Carousel>
									) : (
										<Slider centerMode={true} {...settings}>
											{JSON.parse(props.data.FSCarouselFieldsData).map(
												(item, index) => {
													let actionValue =
														item.linkValue.length > 60
															? item.linkValue.slice(0, 60) + '...'
															: item.linkValue;
													return (
														<div
															key={item.linkText}
															style={{ marginRight: '24px', cursor: 'pointer' }}
															className='ff-welcome-card-parent'
															onClick={() => {
																item.linkValue &&
																	props.handleSubmit(item.linkValue);
																item.linkValue &&
																	props.changeScreen('chatscreen');
															}}>
															<img
																src={item.linkText}
																style={{
																	height:
																		item.linkValue.length > 0 ? '70%' : '100%',
																}}
															/>
															<div
																style={{
																	backgroundColor: 'var(--selectedColor)',
																	cursor: 'pointer',
																	color:
																		props.colorMode === 'dark'
																			? `#fff`
																			: props.colorScale[0],
																	display:
																		item.linkValue.length > 0
																			? 'block'
																			: 'none',
																}}>
																<div>
																	{item.linkValue.length > 60 ? (
																		<Tooltip title={item.linkValue}>
																			<p>{actionValue}</p>
																		</Tooltip>
																	) : (
																		<p>{actionValue}</p>
																	)}
																</div>
															</div>
														</div>
													);
												}
											)}
										</Slider>
									)}
								</div>
							</WelcomeCarousel>
						</React.Fragment>
					</WelcomeText>
					{props.selectedTheme === 'monaco' && (
						<MonacoHomeScreen className='ff-monaco'>
							<div>
								<div className='ff-monaco-welcome-cnt'>
									<div className='ff-chatbot-h4' style={{ width: '88%' }}>
										{props.data.FSWelcomeHeading}
									</div>
									<div
										style={{
											fontSize: '18px',
											width: '88%',
											color: '#606060',
											marginTop: '18px',
											lineHeight: '24px',
										}}>
										{props.data.FSWelcomeSubHeader}
									</div>
								</div>
								<div
									style={{ width: '50%' }}
									className='ff-monaco-welcome-image'>
									<img
										fetchpriority='high'
										style={{ width: '100%', height: '100%' }}
										src={
											props.data.MonacoWelcomeImage
												? props.data.MonacoWelcomeImage
												: GenericImage
										}
										alt=''
									/>
								</div>
							</div>
						</MonacoHomeScreen>
					)}

					{props.selectedTheme === 'E-commerce Chat' &&
					props.data.enableSplashImage === 'true' ? (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							className='E-com-wel-image'>
							<div
								style={{ width: '30%', height: '100%', position: 'relative' }}>
								{mobile && (
									<div
										className='ff-mobile-ss-icon'
										style={{
											display: 'flex',
											justifyContent: 'center',
											margin: '14px 0px',
										}}>
										{' '}
										<ShopperstopLogoMobile />
									</div>
								)}
								{mobile && (
									<div className='ff-ecom-chat-header'>
										{' '}
										<span>{props.data.FSWelcomeHeading}</span>
									</div>
								)}
								<img
									className='ff-ecom-welcome-img'
									style={{ height: '100%', marginTop: '-25px' }}
									src={props.data.EcomChatWelcomeImg}
								/>
							</div>
							<div
								style={{ marginRight: '45px' }}
								className='ff-ecom-welcome-msg'>
								{!mobile && (
									<div className='ff-ecom-chat-header'>
										{' '}
										<span>{props.data.FSWelcomeHeading}</span>
									</div>
								)}
								<div className='ff-ecom-chat-subheader'>
									{props.data.FSWelcomeSubHeader}
								</div>
								<div className='ff-ecom-chat-subheader-text'>
									<div
										style={{
											display:
												props.data.enableSplashImage === 'true'
													? 'block'
													: 'none',
										}}>
										Your Style. Your Way!
									</div>
									<ShopperStopLine />
									{mobile && (
										<div style={{ marginTop: '10px' }}>
											{' '}
											<FlyfishIcon />
										</div>
									)}
								</div>
							</div>

							{!mobile && (
								<div
									style={{ position: 'fixed', bottom: '20px', right: '30px' }}>
									{' '}
									<FlyfishIcon />
								</div>
							)}
							{!mobile && (
								<div
									style={{ position: 'fixed', bottom: '20px', left: '30px' }}>
									{' '}
									<img src={props.data['e-comSplashLogo']} />
								</div>
							)}
						</div>
					) : (
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							<img
								src={props.data.EcomChatWelcomeImg}
								style={{ height: '80vh', marginTop: '-37px' }}
							/>
						</div>
					)}
				</div>
				{/* <WelcomeFooter>
          <div>
            <img src={Home} alt='home' />
          </div>
          <div>
            <img src={Chat} alt='chat' />
          </div>
          <div>
            <img src={Cart} alt='cart' />
          </div>
          <div>
            <img src={Help} alt='help' />
          </div>
        </WelcomeFooter> */}

				{/* {props.quickLinks && props.quickLinks.length ? (
        <div style={{ fontSize: '13px', paddingLeft: '40px' }}>
          <T labelName="quickLinksLabel" />
        </div>
      ) : (
        ''
      )} */}
				{/* <QuickLinksBlock>
        {quickLinks.map((e, i) => {
          return (
            <CustomQuickLink key={i}>
              <img
                onError={e => {
                  e.target.src = getImg(
                    `welcomeScreen/${props.theme}/${1}.svg`
                  );
                }}
                src={getImg(`welcomeScreen/${props.theme}/${i + 1}.svg`)}
                alt={TString({ labelName: 'welcomeScreenLabel' })}
              />
              <ActionItem
                actionLabel={getLabelTranslation(
                  e,
                  intlContext.currentLanguage,
                  'linkText'
                )}
                actionValue={getLabelTranslation(
                  e,
                  intlContext.currentLanguage,
                  'linkValue'
                )}
                handleSubmit={props.handleSubmit}
              />
            </CustomQuickLink>
          );
        })}
      </QuickLinksBlock> */}
			</CustomWelcomeBody>
			{props.selectedTheme === 'monaco' ? (
				<div
					className='ff-chatbot-timestamp PoweredByTheme1'
					style={{
						display: 'flex',
						justifyContent: 'center',
						margin: 0,
						marginBottom: '8px',
						height: '18px',
						color: 'rgba(0, 0, 0, 0.4)',
					}}
					onClick={() => {
						window.open('https://www.flyfish.ai/', '_blank');
					}}>
					<span className='ff-chatbot-body1'>Powered by</span>
					<svg
						style={{
							width: '45px',
							marginLeft: '5px',
							marginBottom: '1px',
						}}
						xmlns='http://www.w3.org/2000/svg'
						xmlnsXlink='http://www.w3.org/1999/xlink'
						id='Layer_2'
						data-name='Layer 2'
						viewBox='0 0 906.61 218.66'>
						<defs>
							<linearGradient
								id='linear-gradient_theme1'
								x1='418.76'
								y1='-4179.93'
								x2='632.69'
								y2='-4362'
								gradientTransform='translate(-3269.72 2745.37) rotate(45)'
								gradientUnits='userSpaceOnUse'>
								<stop offset='0' stopColor='#2c43ba' />
								<stop offset='.63' stopColor='#ab3791' />
								<stop offset='.81' stopColor='#cf3386' />
								<stop offset='1' stopColor='#e36ea4' />
							</linearGradient>
						</defs>
						<g id='Layer_1-2' data-name='Layer 1'>
							<g>
								<g>
									<path
										className='cls-1 flyfishlogo_class_001_theme1'
										d='m236.45,98.37L138.09,0l-72.68,72.68L25.69,32.96,0,58.65l39.72,39.72L1.47,136.62l27.05,27.05,38.25-38.25,71.32,71.32,98.37-98.37Zm-99.72,45.63l-44.27-44.27,45.63-45.63,44.27,44.27-45.63,45.63Z'
									/>
									<path
										className='cls-2 flyfishlogo_class_002_theme1'
										d='m281.93,24.62h96.13v24.32h-64.92v39.77h55.32v24.42h-55.32v58.97h-31.21V24.62Z'
									/>
									<path
										className='cls-2 flyfishlogo_class_002_theme1'
										d='m392.65,18.88h30.37v116.49c0,5.71.89,9.45,2.66,11.22,1.78,1.77,5.38,2.66,10.8,2.66h1.98v22.86c-3.13.7-7.72,1.04-13.78,1.04-11.55,0-19.78-2.85-24.69-8.56-4.91-5.71-7.36-14.23-7.36-25.57V18.88Z'
									/>
									<path
										className='cls-2 flyfishlogo_class_002_theme1'
										d='m469.45,64.18l24.43,82.46,23.9-82.46h31.84l-47.39,124.63c-2.02,5.15-4.16,9.6-6.42,13.36-2.26,3.76-4.94,6.89-8.04,9.39-3.1,2.51-6.63,4.31-10.59,5.43-3.97,1.11-8.66,1.67-14.09,1.67-2.85,0-5.31-.14-7.36-.42-2.05-.28-3.88-.56-5.48-.84v-22.86h5.74c3.83,0,6.99-.28,9.5-.84,2.51-.56,4.61-1.55,6.31-2.97,1.71-1.43,3.2-3.36,4.49-5.79,1.29-2.44,2.66-5.5,4.12-9.19l-43.42-111.58h32.46Z'
									/>
									<path
										className='cls-2 flyfishlogo_class_002_theme1'
										d='m559.63,64.18h15.97v-7.93c0-12.53,3.64-22.01,10.91-28.44,7.27-6.44,17.83-9.65,31.68-9.65,2.44,0,5.06.12,7.88.37,2.82.24,5.24.64,7.25,1.2v22.86h-4.91c-8,0-13.74,1.17-17.22,3.5-3.48,2.33-5.22,7.15-5.22,14.46v3.65h26.3v23.07h-26.3v84.86h-30.37v-84.86h-15.97v-23.07Z'
									/>
									<path
										className='cls-2 flyfishlogo_class_002_theme1'
										d='m653.45,64.18h30.37v107.93h-30.37v-107.93Z'
									/>
									<path
										className='cls-2 flyfishlogo_class_002_theme1'
										d='m711.55,141.32c4.73,3.27,9.83,5.83,15.29,7.67,5.46,1.84,10.84,2.77,16.13,2.77,5.01,0,8.94-.92,11.79-2.77,2.85-1.84,4.28-4.68,4.28-8.51,0-2.57-.75-4.68-2.24-6.32-1.5-1.64-4.12-3.01-7.88-4.12l-17.74-5.22c-8.84-2.57-15.57-6.31-20.2-11.22-4.63-4.91-6.94-11.33-6.94-19.26,0-5.43,1.08-10.18,3.24-14.25,2.16-4.07,5.11-7.5,8.87-10.28,3.76-2.78,8.28-4.89,13.57-6.32,5.29-1.43,11.06-2.14,17.33-2.14,7.72,0,15.2,1.04,22.44,3.13,7.24,2.09,13.36,4.98,18.37,8.66l-9.6,19.21c-8.84-5.29-18.09-7.93-27.77-7.93-5.01,0-8.94.82-11.79,2.45-2.85,1.64-4.28,4.12-4.28,7.46,0,2.71.85,4.8,2.56,6.26,1.71,1.46,3.98,2.64,6.84,3.55l16.28,4.91c9.95,2.99,17.31,6.87,22.08,11.64,4.77,4.77,7.15,11.22,7.15,19.36,0,10.86-4.02,19.38-12.06,25.57-8.04,6.19-19.05,9.29-33.04,9.29-8.84,0-16.96-1.25-24.37-3.76-7.41-2.51-13.97-6.05-19.68-10.65l11.38-19.21Z'
									/>
									<path
										className='cls-2 flyfishlogo_class_002_theme1'
										d='m806.51,18.88h30.37v58.97c3.27-5.15,7.72-9.19,13.36-12.11,5.64-2.92,12.18-4.38,19.62-4.38,12.25,0,21.43,3.46,27.56,10.39,6.12,6.92,9.19,16.86,9.19,29.8v70.56h-30.37v-68.37c0-12.53-5.57-18.82-16.7-18.89-6.82,0-12.3,2.47-16.44,7.41-4.14,4.94-6.21,11.83-6.21,20.67v59.18h-30.37V18.88Z'
									/>
									<rect
										className='cls-2 flyfishlogo_class_002_theme1'
										x='654.73'
										y='21.31'
										width='30.79'
										height='27.56'
										rx='13.78'
										ry='13.78'
									/>
								</g>
							</g>
						</g>
					</svg>
				</div>
			) : null}
		</React.Fragment>
	);
};

export default Theme1;
